import React from 'react';
import { useEducationHub } from '../../../contexts/EducationHubContext';
import { useSidebar } from '../../../contexts/SidebarContext';
import QuickStats from './QuickStats';
import styles from '../../../styles/EducationHub.module.css';

interface OverviewSectionProps {
  quickStats: {
    totalGuides: number;
    completedGuides: number;
    totalNews: number;
    latestUpdate: any;
  };
}

const OverviewSection: React.FC<OverviewSectionProps> = ({ quickStats }) => {
  const { guides, news } = useEducationHub();
  const { setActiveItem } = useSidebar();

  const recentGuides = guides.slice(0, 3);
  const recentNews = news.slice(0, 3);

  return (
    <div>
      <div className={styles.sectionTitle}>
        Overview
      </div>

      <QuickStats quickStats={quickStats} />

      {recentGuides.length > 0 && (
        <div className={styles.overviewBlock}>
          <div className={styles.overviewBlockHeader}>
            <h3 className={styles.overviewBlockTitle}>Recent Guides</h3>
            <button
              className={styles.viewAllBtn}
              onClick={() => setActiveItem('guides')}
            >
              View all →
            </button>
          </div>
          <div className={styles.overviewGrid}>
            {recentGuides.map(guide => (
              <div key={guide._id} className={styles.overviewCard}>
                <div className={styles.overviewCardTitle}>{guide.title}</div>
                <div className={styles.overviewCardMeta}>
                  {guide.category} · {guide.difficulty}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {recentNews.length > 0 && (
        <div className={styles.overviewBlock}>
          <div className={styles.overviewBlockHeader}>
            <h3 className={styles.overviewBlockTitle}>Latest News</h3>
            <button
              className={styles.viewAllBtn}
              onClick={() => setActiveItem('news')}
            >
              View all →
            </button>
          </div>
          <div className={styles.overviewGrid}>
            {recentNews.map(item => (
              <div key={item._id} className={styles.overviewCard}>
                <div className={styles.overviewCardTitle}>{item.title}</div>
                <div className={styles.overviewCardMeta}>{item.category}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {quickStats.latestUpdate && (
        <div className={styles.overviewBlock}>
          <div className={styles.overviewBlockHeader}>
            <h3 className={styles.overviewBlockTitle}>Latest Update</h3>
            <button
              className={styles.viewAllBtn}
              onClick={() => setActiveItem('updates')}
            >
              View all →
            </button>
          </div>
          <div className={`${styles.overviewCard} ${styles.overviewCardFull}`}>
            <div className={styles.overviewCardTitle}>
              v{quickStats.latestUpdate.version} — {quickStats.latestUpdate.title}
            </div>
            <div className={styles.overviewCardMeta}>
              {quickStats.latestUpdate.type} · {quickStats.latestUpdate.category}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OverviewSection;
